import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import VueProgressBar from 'vue-progressbar'
// import Vuex from 'vuex'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './plugins/http'
import interceptor from './interceptor'
import VueHtmlToPaper from 'vue-html-to-paper'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import configs from './configs'
import filters from './filters'
import './quasar'

const htmlToPapperOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    // 'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}


Vue.config.productionTip = false
Vue.use(http, { baseURL: configs.baseURL, interceptor })
Vue.use(VueProgressBar, {
  color: '#ffdd09',
  failedColor: 'red',
  thickness: '7px'
})
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)
Vue.use(VueHtmlToPaper, htmlToPapperOptions)

new Vue({
  router,
  store,
  filters,
  render: h => h(App),
}).$mount('#app')
